import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import PropTypes from 'prop-types';
import { CHOOSE_ADD } from '../addressUtils/addressConstants';

const required = (value) => (value ? undefined : 'Required');

const isRegister = (type) => type === 'registeredAddress';

const ChooseAddressComponent = ({ type, formValues, chooseAddress, isValidate }) => {
  return (
    <Content>
      {({
        radioFieldErrorMessage,
        liveInUK,
        tradingAddressSoloError,
        radioFieldYes = '',
        radioFieldNo = ''
      }) => (
        <Field name={`${type}.${CHOOSE_ADD}`} subscription={{ touched: true, error: true }}>
          {({ meta: { touched, error } }) => (
            <GenericFieldWrapper
              name={`${type}.${CHOOSE_ADD}`}
              title={liveInUK}
              validationMessage={
                isValidate && touched && !!error
                  ? isRegister(type)
                    ? radioFieldErrorMessage
                    : tradingAddressSoloError
                  : ''
              }
            >
              <Field
                name={`${type}.${CHOOSE_ADD}`}
                value={radioFieldYes}
                type="radio"
                validate={isValidate && required}
              >
                {({ input }) => (
                  <GenericRadio.InlineSet
                    {...input}
                    groupName={`${type}`}
                    items={[
                      { id: radioFieldYes, labelText: radioFieldYes },
                      { id: radioFieldNo, labelText: radioFieldNo }
                    ]}
                    onChange={(selectedId) => {
                      input.onChange(selectedId);
                      chooseAddress(type, { [CHOOSE_ADD]: selectedId });
                    }}
                    selectedId={formValues[type] ? formValues[type][CHOOSE_ADD] : null}
                  />
                )}
              </Field>
            </GenericFieldWrapper>
          )}
        </Field>
      )}
    </Content>
  );
};

ChooseAddressComponent.propTypes = {
  type: PropTypes.string.isRequired
};

export default ChooseAddressComponent;
